import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

import { AlertsManagerWidgetEntity } from '../../../pages/dashboard/features/alerts-manager-widget/AlertsManagerWidget.entity';
import { parseAlertsManagerWidgetInternalState } from '../../../pages/dashboard/features/alerts-manager-widget/parseAlertsManagerWidget';

export function mapAlertsManagerTemplate(
  template: TSerializedWidgetTemplate,
  index: number,
  options?: { wellId: number | null },
): AlertsManagerWidgetEntity {
  const { size, position } = template;

  const internalState = parseAlertsManagerWidgetInternalState(template.internalState ?? {});

  const alertsManagerWidget = new AlertsManagerWidgetEntity(
    {
      wellId: options?.wellId ?? null,
      stateParams: internalState.stateParams,
      type: 'alerts-manager-widget',
      isEditMode: internalState.isEditMode ?? false,
    },
    {
      groupId: template.groupId || null,
      isGroupsDefaultOpened: false,
      uuid: template.uuid,
      isPinned: false,
      isFullscreen: false,
      zIndex: index + 1,
      size: {
        w: size.w,
        h: size.h,
      },
      position: {
        x: position.x,
        y: position.y,
      },
    },
  );

  return alertsManagerWidget;
}
